import { ChangeDetectionStrategy, Component, booleanAttribute, inject, input } from '@angular/core';
import { Download, Share } from 'lucide-angular';
import { AdsButtonComponent, AdsIconDirective } from '../ads';
import { PwaInstalacijaService } from './pwa-instalacija.service';

/**
 * „Instaliraj aplikaciju”: diskretan gumb (Android / Chromium) ili kratka uputa (iOS).
 * Kad je aplikacija instalirana ili preglednik ne nudi instalaciju, ne prikazuje ništa.
 *
 *   <app-pwa-instaliraj />                       postavke: gumb ili uputa za iOS
 *   <app-pwa-instaliraj [iosUputa]="false" />    ljuska / izbornik: samo gumb
 */
@Component({
  selector: 'app-pwa-instaliraj',
  imports: [AdsButtonComponent, AdsIconDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (instalacija.mozeInstalirati()) {
      <div class="ds-applikator pwa-inst">
        <button appAdsButton="ghost" velicina="sm" type="button" (click)="instaliraj()">
          <svg [appAdsIcon]="ikonaPreuzmi"></svg>Instaliraj aplikaciju
        </button>
      </div>
    } @else if (iosUputa() && instalacija.prikaziIosUputu()) {
      <p class="ds-applikator pwa-inst pwa-inst__ios">
        Dodajte aplikaciju na početni zaslon: u pregledniku dodirnite Dijeli
        <svg [appAdsIcon]="ikonaDijeli"></svg>, zatim „Dodaj na početni zaslon”.
      </p>
    }
  `,
  styles: `
:host{display:contents}
.pwa-inst{background:transparent}
.pwa-inst__ios{max-width:60ch;font-size:14px;line-height:1.5;color:var(--meta)}
.pwa-inst__ios svg{display:inline-block;vertical-align:-.15em;color:var(--ink)}
`,
})
export class PwaInstalirajComponent {
  protected readonly instalacija = inject(PwaInstalacijaService);
  /** Prikaži uputu za iOS kad gumba nema (u postavkama da, u ljusci ne). */
  readonly iosUputa = input(true, { transform: booleanAttribute });
  protected readonly ikonaPreuzmi = Download;
  protected readonly ikonaDijeli = Share;

  protected instaliraj(): void {
    void this.instalacija.instaliraj();
  }
}
